export default __webpack_public_path__ + "static/digital-transformation-robot-52c5640f11e3523a784a4ab487abe28f.png";